"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowActions = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.RowActions = styled_components_1.default.ul(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  grid-auto-flow: column;\n  grid-gap: 1rem;\n  align-items: center;\n  justify-content: flex-end;\n  height: 100%;\n  list-style-type: none;\n  margin-top: 0;\n  margin-bottom: 0;\n"], ["\n  display: grid;\n  grid-auto-flow: column;\n  grid-gap: 1rem;\n  align-items: center;\n  justify-content: flex-end;\n  height: 100%;\n  list-style-type: none;\n  margin-top: 0;\n  margin-bottom: 0;\n"])));
var templateObject_1;